import styled from 'styled-components';

export const StyledFormError = styled.div`
    color: #D33A2C;
    margin-top: 6px;
    font-size: 13px;
    line-height: 1.3;
`
